import { HowToSpecialty as HygraphHowToSpecialtyProps } from '@/lib/types';

import { HowToGroupProps } from '@/components/how-to';
import { HowToSpecialtyProps } from '@/components/how-to-specialty';

import richTextTransformer from '@/hygraph/transformers/rich-text.transformer';

export default function howToSpecialtyTransformer(
  howToGroup: HygraphHowToSpecialtyProps
): HowToSpecialtyProps {
  return {
    title: howToGroup.title as string,
    body: richTextTransformer({
      content: howToGroup.body?.raw,
    }) as HowToGroupProps['body'],
  };
}
